/**
 * Project Members Page - Wrapper for ProjectMembers component
 */
import { useParams } from 'react-router-dom';
import { ProjectMembers } from '@/components/ProjectMembers';

export const ProjectMembersPage = () => {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    return <div className="p-6 text-center">Project ID is required</div>;
  }

  return <ProjectMembers projectId={projectId} />;
};

